import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  QuizzesPage,
  QuizzesEdit,
  QuestionsEdit,
  QuestionAnswerCMS,
  QuestionQRPage,
  QuizResultsPage,
  MyQuizAnswersPage,
} from '../pages/CMSPages/index';
import React from 'react';

const FriViaRoutes = () => (
  <>
    <Route
      path={routes.cmsQuizzes}
      element={
        <CMSWrapper permissions={['quizzes.index']}>
          <QuizzesPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsQuizzesCreate}
      element={
        <CMSWrapper permissions={['quizzes.store']}>
          <QuizzesEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsQuizzesEdit}/:id`}
      element={
        <CMSWrapper permissions={['quizzes.show']}>
          <QuizzesEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsQuizQuestionsCreate}
      element={
        <CMSWrapper permissions={['quiz-questions.store']}>
          <QuestionsEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsQuizQuestionsEdit}/:id`}
      element={
        <CMSWrapper permissions={['quiz-questions.show']}>
          <QuestionsEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsQuizQuestionAnswer}/:id`}
      element={
        <CMSWrapper permissions={['quiz-student-answers.store']}>
          <QuestionAnswerCMS />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsQuizQuestionQR}/:id`}
      element={
        <CMSWrapper permissions={['quizzes.show']}>
          <QuestionQRPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsQuizResults}/:id`}
      element={
        <CMSWrapper permissions={['quiz-student-answers.index']}>
          <QuizResultsPage mode="quiz" />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsQuizQuestionResults}/:id`}
      element={
        <CMSWrapper permissions={['quiz-questions.show']}>
          <QuizResultsPage mode="question" />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMyQuizAnswers}
      element={
        <CMSWrapper permissions={['quiz-student-answers.store']}>
          <MyQuizAnswersPage />
        </CMSWrapper>
      }
    />
  </>
);

export default FriViaRoutes;
